import dayjs from "dayjs";

export const months = {
  1: "January",
  2: "February",
  3: "March",
  4: "April",
  5: "May",
  6: "June",
  7: "July",
  8: "August",
  9: "September",
  10: "October",
  11: "November",
  12: "December",
};

const startYear = 2024;
const endYear = dayjs().year() + 10;

export const years = Array.from(
  { length: endYear - startYear + 1 },
  (_, i) => startYear + i
);
